import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Sidebar } from 'primereact/sidebar';
import { useEffect, useState } from 'react';
import FormInput from '../../../../components/Form/FormInput';
import ImageForm from '../../common/image/ImageForm';

function CircumstanceManager({ isOpen, onClose, circumstance, loading, onUpdate, onCreate }) {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [images, setImages] = useState([]);

  useEffect(() => {
    if (circumstance) {
      setTitle(circumstance.title);
      setImages(circumstance.images);
      setDescription(circumstance.description);
    } else {
      setTitle('');
      setImages([]);
      setDescription('');
    }
  }, [circumstance, isOpen]);

  const handleValidate = () => {
    const circumstancePayload = {
      title,
      images: images.map((image) => image.id),
      description
    };
    circumstance ? onUpdate(circumstancePayload) : onCreate(circumstancePayload);
  };

  const formIsValid = () => {
    return images.length > 0;
  };

  const footerButtons = (
    <div className="manage-footer">
      <Button
        key={'validate'}
        label={`Valider la ${circumstance ? 'modification' : 'création'}`}
        className="w-full"
        onClick={handleValidate}
        severity="success"
        disabled={!formIsValid()}
        loading={loading}
      />
    </div>
  );

  return (
    <Sidebar
      style={{ width: 700 }}
      visible={isOpen}
      position="right"
      onHide={() => onClose(false)}
      header={
        <h3 className="text-slate-800 text-2xl font-medium">{`${circumstance ? 'Modifier' : 'Ajouter'} une actualité`}</h3>
      }>
      <div className="sidebar-content-container">
        <div className="form-wrapper !pb-60">
          <FormInput label={`Titre de l'actualité`}>
            <InputText
              id="title"
              value={title}
              maxLength={300}
              placeholder="Veuillez saisir le titre de l'article"
              onChange={(e) => setTitle(e.target.value)}
            />
          </FormInput>
          <FormInput label={'Description'}>
            <InputText
              id="description"
              value={description}
              maxLength={300}
              placeholder="Veuillez saisir la description de l'actualité"
              onChange={(e) => setDescription(e.target.value)}
            />
          </FormInput>
          {images.length > 0 && (
            <div className="flex flex-wrap gap-5">
              {images.map((image, index) => (
                <ImageForm
                  key={image.id ?? index}
                  image={image}
                  setImage={(img) =>
                    setImages((prevImages) =>
                      prevImages.map((prevImage, i) => (i === index ? img : prevImage))
                    )
                  }
                  deleteImage={() =>
                    setImages((prevImages) => prevImages.filter((_, i) => i !== index))
                  }
                  label={`Image ${index + 1}`}
                />
              ))}
            </div>
          )}
          <ImageForm
            key="add-new-image"
            image={undefined}
            setImage={(img) => setImages((prevImages) => [...prevImages, img])}
            label="Ajouter une nouvelle image"
            required={images.length === 0}
          />
        </div>
        {footerButtons}
      </div>
    </Sidebar>
  );
}

export default CircumstanceManager;
